import { Field, Int, ObjectType } from '@nestjs/graphql'
import { BaseModelDto } from '../../base/baseModel.dto'
import { ArcClaimDto } from '../claim'
import { ArcReviewSiteDto } from './reviewSite.model.dto'

@ObjectType()
export class ArcReviewDto extends BaseModelDto {
  @Field(t => ArcClaimDto, { nullable: true })
  claim?: ArcClaimDto

  @Field(t => Int)
  claimId!: number

  @Field()
  title!: string

  @Field()
  review!: string

  @Field({ nullable: true })
  reviewLanguage?: string

  @Field({ nullable: true })
  translatedReview?: string

  @Field()
  rating!: number

  @Field({ nullable: true })
  privateFeedback?: string

  @Field({ nullable: true })
  disclaimer?: string

  @Field(t => [ArcReviewSiteDto], { nullable: true })
  sites?: ArcReviewSiteDto[]
}
